module.exports = __webpack_public_path__ + "img/img86.e2bc63c9.svg";